import * as yup from 'yup';
import * as FORM_TYPES from '../constants/forms.constants';

// Fields
const SCENARIO_FIELDS = {
  NAME: 'name',
  COMMENT: 'comment',
  OWNER: 'owner',
  FROMDATE: 'fromDate',
  TODATE: 'toDate',
};

// Form Definition
const definition = () => [
  {
    label: 'Scenario Name',
    key: SCENARIO_FIELDS.NAME,
    component: FORM_TYPES.INPUT,
    validation: yup.string().min(2).required(),
  },

  {
    label: 'Comment',
    key: SCENARIO_FIELDS.COMMENT,
    component: FORM_TYPES.INPUT,
    validation: yup.string(),
  },

  {
    label: 'Owner',
    key: SCENARIO_FIELDS.OWNER,
    component: FORM_TYPES.FIELD_TEXT,
    validation: yup.string(),
  },

  {
    label: 'From Date',
    key: SCENARIO_FIELDS.FROMDATE,
    component: FORM_TYPES.FIELD_TEXT,
    validation: yup.string(),
  },

  {
    label: 'To Date',
    key: SCENARIO_FIELDS.TODATE,
    component: FORM_TYPES.FIELD_TEXT,
    validation: yup.string(),
  },
];

// Validation
const schema = () => yup.object().shape({
  ...definition().reduce((acc, curr) => ({ ...acc, [curr.key]: curr.validation }), {}),
});

const scenarioViewEdit = defaultData => (
  {
    definition: definition(),
    initialValues: defaultData,
    schema: schema(),
  }
);

export default scenarioViewEdit;
